/**
* @file: DrawRegion
* @author: wence
*/

export default class DrawRegion {
    constructor(config) {
        this.config = config || {};
        this.canvas = document.getElementById(this.config.id);
        this.locationScale = 1;

        this.ctx = this.canvas.getContext('2d');
        this.ratio = this.getPixelRatio();
        this.canvas.style = `transform: scale(${1 / this.ratio})`;
    }

    drawImage(config, callback, errorCallback) {
        let curConfig = config || {};
        let url = curConfig.url;
        let img = document.createElement('img');
        img.src = url;

        let self = this;
        this.locationScale = 1;
        img.onload = function () {
            // 超过宽高的
            if (img.height > self.config.height || img.width > self.config.width) {
                let locationScaleH = self.config.height / this.height;
                let locationScaleW = self.config.width / this.width;
                if (locationScaleH > locationScaleW) {
                    this.width = self.config.width;
                    self.locationScale = locationScaleW;
                }
                else if (locationScaleH < locationScaleW) {
                    this.height = self.config.height;
                    self.locationScale = locationScaleH;
                }
                else {
                    this.width = self.config.width;
                    self.locationScale = locationScaleW;
                }
            }

            let imageHeight = this.height;
            let imageWidth = this.width;
            let realWidth = self.getRealSize(imageWidth);
            let realHeight = self.getRealSize(imageHeight);

            self.canvas.height = realHeight;
            self.canvas.width = realWidth;

            self.ctx.drawImage(this, 0, 0, self.canvas.width, self.canvas.height);

            if (callback) {
                callback();
            }

            self.ctx.restore();
            document.body.removeChild(img);
        };

        img.onerror = function () {
            if (errorCallback) {
                errorCallback();
            }
        };

        document.body.appendChild(img);
    }
    drawStrokeInImage(config) {
        let curConfig = config || {};
        let list = curConfig.list || [];

        for (let i = 0; i < list.length; i++) {
            this.drowStrokeWithText(list[i]);
        }
    }

    getRealSize(size) {
        return size * this.ratio;
    }

    clearDraw() {
        this.canvas.height = this.canvas.height;
    }

    getPixelRatio() {
        let backingStore = this.ctx.backingStorePixelRatio
            || this.ctx.webkitBackingStorePixelRatio
            || this.ctx.mozBackingStorePixelRatio
            || this.ctx.msBackingStorePixelRatio
            || this.ctx.oBackingStorePixelRatio
            || this.ctx.backingStorePixelRatio
            || 1;
        return (window.devicePixelRatio || 1) / backingStore;
    }

    drowStrokeWithText(config) {
        let curConfig = config || {};
        let x = this.getRealSize((curConfig.location.left || 0) * this.locationScale);
        let y = this.getRealSize((curConfig.location.top || 0) * this.locationScale);
        let width = this.getRealSize((curConfig.location.width || 0) * this.locationScale);
        let height = this.getRealSize((curConfig.location.height || 0) * this.locationScale);
        let fontSize = this.getRealSize(12);
        let textCenterPiontX = Math.round(x + width / 2);
        let textCenterPiontY = y < 25 ? (height + y + 25) : (y - 10);
        let text = curConfig.text || '';
        let textColor = curConfig.textColor || '';
        this.ctx.strokeStyle = curConfig.strokeStyle || 'red';
        this.ctx.textAlign = 'center';
        this.ctx.fillStyle = textColor;
        this.ctx.font = fontSize + 'px PingFangSC-Regular, "PingFang SC", "Helvetica Neue", Helvetica,'
            + '"Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif';

        this.ctx.lineWidth = curConfig.lineWidth || this.getRealSize(1);
        this.ctx.strokeRect(x, y, width, height);
        this.ctx.stroke();

        this.ctx.fillText(text, textCenterPiontX, textCenterPiontY);
        this.ctx.restore();
    }
}



// WEBPACK FOOTER //
// ./src/containers/product/components/drawRegion.js